// ... existing code ...

import { GETREQUESTOPTIONS, instance } from '../apiService';

// ImplantNote API functions
export const createImplantNote = async (
    implantId: string,
    title: string,
    note: string,
    attachedFiles?: string[]
) => {
    const response = await instance.post(
        '/api/implant-notes/create',
        { implantId, title, note, attachedFiles },
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const getImplantNotes = async (implantId: string) => {
    const response = await instance.get(
        `/api/implant-notes/implant/${implantId}`,
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const getAllDepartmentNotes = async (implantId?: string) => {
    const url = implantId
        ? `/api/implant-notes?implantId=${implantId}`
        : '/api/implant-notes';

    const response = await instance.get(url, GETREQUESTOPTIONS());
    return response.data;
};

export const getImplantNoteById = async (noteId: string) => {
    const response = await instance.get(
        `/api/implant-notes/${noteId}`,
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const updateImplantNote = async (
    noteId: string,
    title: string,
    note: string,
    editComment: string,
    attachedFiles?: string[]
) => {
    const response = await instance.put(
        `/api/implant-notes/update/${noteId}`,
        { title, note, editComment, attachedFiles },
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const deleteImplantNote = async (noteId: string) => {
    const response = await instance.delete(
        `/api/implant-notes/delete/${noteId}`,
        GETREQUESTOPTIONS()
    );
    return response.data;
};
